<app-select appearance="outline"
            [templateTrigger]="dataExporterUsageTriggerT"
            label="export.destination.title"
            [controlName]="controlName"
            keyText="text"
            [control]="control"
            [form]="form"
            htmlLabel="htmlLabel"
            groupItems="groupItems"
            [options]="options"></app-select>
<ng-template #dataExporterUsageTriggerT>
  <ng-container *ngIf="form.controls[controlName].value">
    <img *ngIf="form.controls[controlName].value.image"
         [src]="form.controls[controlName].value.image"
         style="height: 1rem; margin-right: 0.5rem; vertical-align: middle;"/>
    {{ form.controls[controlName].value.text }}
  </ng-container>
</ng-template>
